"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeatureServiceLive = void 0;
const HttpProvider_1 = require("../utils/HttpProvider");
class FeatureServiceLive {
    isGenerallyAvailable(featureName) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.get(`/feature/${featureName}`);
            return response.data;
        });
    }
    isFeatureEnabledForUser(companyId, featureName) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.get(`/feature/${companyId}/${featureName}/user-access`);
            return response.data;
        });
    }
}
exports.FeatureServiceLive = FeatureServiceLive;
//# sourceMappingURL=FeatureServiceLive.js.map